import type { ReactNode } from 'react';

type MainSize = 'xs' | 'sm' | 'md' | 'lg';

export interface MainContainerProps {
  /** ページタイトル */
  title?: string;
  /** コンテンツの最大幅 */
  size?: MainSize;
  /** ヘッダーに表示するボタン等 */
  headerButtons?: ReactNode;
  /** 子要素 */
  children: ReactNode;
  /** 追加のクラス名 */
  className?: string;
}

/**
 * AIPデザインシステムのメインコンテナコンポーネント
 */
export const MainContainer: React.FC<MainContainerProps> = ({
  title,
  size = 'md',
  headerButtons,
  children,
  className = '',
}) => {
  return (
    <div className={`aip-main ${className}`.trim()} data-size={size}>
      {/* ヘッダー */}
      <header className="aip-main__header">
        <div className="aip-main__header-container">
          {title && <h1 className="aip-main__header-title">{title}</h1>}
          {headerButtons && (
            <div className="aip-main__header-buttons">{headerButtons}</div>
          )}
        </div>
      </header>

      {/* コンテンツエリア */}
      <div className="aip-main__content">{children}</div>
    </div>
  );
};

export default MainContainer;

